<template>
  <div class="form-group form-row">
    <label :for="safeId()" class="col-sm-4 col-form-label" v-if="label">{{ labelText }}</label>
    <div class="col-sm-4">
      <input type="text" class="form-control" :id="safeId()" v-model.lazy="localColor">
    </div>
    <div class="col-sm-2">
      <input type="color" class="form-control" :id="safeId()" v-model.lazy="localColor">
    </div>
    <div class="col-sm-2">
      <input type="number" class="form-control" min="0" max="1" step="0.01" v-model.lazy="localAlpha">
    </div>
  </div>
</template>

<script>
  import tinycolor from 'tinycolor2'

  export default {
    name: 'color-select-group',
    props: ['label', 'value'],
    data () {
      const color = tinycolor(this.value)
      return {
        localColor: color.toHexString(),
        localAlpha: color.getAlpha()
      }
    },
    computed: {
      labelText () {
        return {
          'backgroundColor1': 'Background color 1',
          'fontColor1': 'Font color 1',
          'backgroundColor2': 'Background color 2',
          'fontColor2': 'Font color 2'
        }[this.label] || this.label
      }
    },
    watch: {
      localColor: function (val) {
        this.$emit('input', tinycolor(val).setAlpha(this.localAlpha).toRgbString())
        this.$emit('change')
      },
      localAlpha: function (val) {
        this.$emit('input', tinycolor(this.localColor).setAlpha(val).toRgbString())
      },
      value: function (val) {
        const color = tinycolor(val)
        this.localColor = color.toHexString()
        this.localAlpha = color.getAlpha()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/color-select-group.vue